export default defineNuxtRouteMiddleware(async () => {
  const nuxtApp = useNuxtApp()
  // SSR already gates this load, so denied users never reach hydration.
  if (!import.meta.server && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) {
    return
  }

  const event = useRequestEvent()

  try {
    await $fetch('/api/claudika/access', {
      headers: event?.headers,
      retry: false,
    })
  } catch (error) {
    // A denied probe is expected for users without KI access, so don't report it as an app error
    if (isFetchError(error, 403)) {
      return navigateTo({ name: 'oversikt-index' })
    }
    throw error
  }
})
